import api from "../../utils/api";

const baseEndpoint = process.env.REACT_APP_API_BASE_URL
  ? process.env.REACT_APP_API_BASE_URL
  : "";
export const baseAPI = api(baseEndpoint);
export const baseFDAPI = api(baseEndpoint, "formMultipart/form-data");

const feedbackService = {

    feedback: async (data: any) => {
      return baseAPI.post(`/Mobile/SelfService/Feedback`, data);
    },
    whistleBlowing: async (data: any) => {
      return baseFDAPI.post(`/v2/SelfServices/whistleblowing`, data);
    },
};

export default feedbackService;